import { useCallback, useEffect, useRef } from 'react';

export function useMenuRequest() {
  const requests = useRef(new Set());
  useEffect(() => {
    const pending = requests.current;
    return () => { pending.forEach((controller) => controller.abort()); };
  }, []);
  return useCallback(async (path, options = {}) => {
    const controller = new AbortController();
    requests.current.add(controller);
    try {
      const response = await fetch(path, {
        ...options, cache: 'no-store', signal: controller.signal,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, ...(options.body ? { 'Content-Type': 'application/json' } : {}) },
      });
      const body = await response.json().catch(() => ({}));
      // Some adapters can resolve despite abort; never accept an old venue's response.
      if (controller.signal.aborted) throw Object.assign(new Error('Request cancelled'), { name: 'AbortError' });
      if (!response.ok) throw new Error(body.error || body.message || `Menu publishing request failed (${response.status})`);
      return body;
    } finally { requests.current.delete(controller); }
  }, []);
}

export const isCancelled = (error) => error.name === 'AbortError';
export const publishingButton = 'rounded bg-gray-700 px-3 py-2 text-sm text-white disabled:opacity-40';
export const publishingInput = 'block w-full rounded bg-gray-900 border border-gray-600 px-3 py-2 text-white';
